import { guard } from '../services/features';

window.fishnet = window.fishnet || {};

window.fishnet.launcher = {
  init: (eventBus) => {
    guard('service-workers', () => {
      window.fishnet.registration.init().then(() => {
        window.fishnet.fallbackUpdater.init(eventBus);
      });
    });
  },
};
